// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_qdb","image":"az_rdb","description":"az_sdb"};